export const WelcomeCallMe = () => {
  window.location.href = "Welcome/callme.html";
  return <></>;
};